import api from './api.service';

export type MaterialAuditRow = {
  source: 'work_order' | 'production_request';
  source_id: string;
  source_number: string;
  finished_item: string;
  promise_date: string | null;
  component_item_id: string | null;
  component_code: string | null;
  component_name: string | null;
  required_qty: number;
  uom: string | null;
  free_stock: number;
  open_po_qty: number;
  allocated_stock: number;
  allocated_po: number;
  shortage_qty: number;
  note: string | null;
};

export type MasterScheduleWorkOrder = {
  id: string;
  work_order_number: string;
  planned_quantity: number;
  planned_start_date: string | null;
  planned_end_date: string | null;
  work_order_status: string;
};

export type MasterScheduleRow = {
  item_key: string;
  item_id: string | null;
  item_code: string;
  item_name: string;
  weeks: Array<{ week_start: string; demand_qty: number; work_order_qty: number }>;
  work_orders: MasterScheduleWorkOrder[];
};

async function unwrap<T>(promise: Promise<{ success?: boolean; data?: T; message?: string }>): Promise<T> {
  const response = await promise;
  if (response.success === false || response.data === undefined) {
    throw new Error(response.message || 'Request failed');
  }
  return response.data;
}

export const productionPlanningService = {
  materialAudit: () => unwrap<MaterialAuditRow[]>(api.get('/manufacturing/planning/material-audit')),
  masterSchedule: (weeks = 8) =>
    unwrap<{ week_starts: string[]; rows: MasterScheduleRow[] }>(
      api.get('/manufacturing/planning/master-schedule', { params: { weeks } })
    ),
  moveWorkOrderDates: (id: string, planned_start_date: string, planned_end_date: string) =>
    unwrap<MasterScheduleWorkOrder>(
      api.put(`/manufacturing/planning/work-orders/${id}/dates`, { planned_start_date, planned_end_date })
    ),
};
